import React from 'react';
import { BuyerOffer } from '@/types';
import BuyerOfferDisplay from './BuyerOfferDisplay';
import theme from './BuyerOfferList.module.scss';
import { orderBy } from 'lodash-es';

interface BuyerOfferListProps {
    buyerOffers: BuyerOffer[];
}

const BuyerOfferList: React.FC<BuyerOfferListProps> = ({ buyerOffers }) => {
    const sortedOffers = orderBy(buyerOffers, 'sendDate', 'desc');

    return (
        <ul className={theme.list}>
            {sortedOffers.map((x) => (
                <li key={x.id}>
                    <BuyerOfferDisplay buyerOffer={x} />
                </li>
            ))}
        </ul>
    );
};

export default BuyerOfferList;
